export * from '@primeuix/themes/nora/breadcrumb';
export { default } from '@primeuix/themes/nora/breadcrumb';
